// import Vue from 'vue'
import search from '../components/search.vue'
import button from '../components/button.vue'
export default function (Vue) {
  Vue.component('search', search)
  Vue.component('buttons', button)
}
